import { useState } from "react";
import styles from "./styles.module.css";


export default function ToggleButtons({
  txtButton1,
  txtButton2,
  valueButton1,
  valueButton2,
  handleSelect,
  wl,
}) {
  const [selected, setSelected] = useState(valueButton1);

  const handleSelectTypePerson = (type) => {
    setSelected(type);
    handleSelect(type);
  };

  return (
    <div className={styles["toggle-buttons"]}>
      <button
        type="button"
        className={`${styles.btn} ${
          selected === valueButton1 ? styles.active : ""
        }`}
        style={{
          background:
            selected === valueButton1 ? wl.cor_tema_primaria : "#DDE1E7",
          color: selected === valueButton1 ? "#FFF" : "#000",
        }}
        onClick={() => handleSelectTypePerson(valueButton1)}
      >
        {txtButton1}
      </button>
      <button
        type="button"
        className={`${styles.btn}  ${
          selected === valueButton2
            ? `${styles.active} ${styles.alt}`
            : styles.alt
        }`}
        style={{
          background:
            selected === valueButton2 ? wl.cor_tema_primaria : "#DDE1E7",
          color: selected === valueButton2 ? "#FFF" : "#000",
        }}
        onClick={() => handleSelectTypePerson(valueButton2)}
      >
        {txtButton2}
      </button>
    </div>
  );
}
